import { render, staticRenderFns } from "./remove-info.vue?vue&type=template&id=85070a6e&scoped=true"
import script from "./remove-info.vue?vue&type=script&lang=js"
export * from "./remove-info.vue?vue&type=script&lang=js"
import style0 from "./remove-info.vue?vue&type=style&index=0&id=85070a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85070a6e",
  null
  
)

export default component.exports